/*! * gulp-hbs-boilerplate | Jon Welsh | git+https://github.com/jonwelsh/gulp-hbs-boilerplate.git */
/*!
 * gulp-hbs-boilerplate 
 * A Handlebars and Gulp 4 boilerplate 
 * Jon Welsh 
 * git+https://github.com/jonwelsh/gulp-hbs-boilerplate.git 
 */
"use strict";
//# sourceMappingURL=maps/vendor.min.js.map
